import DapDSStack from './stack.component'

export * from './stack.component'
export default DapDSStack

DapDSStack.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-stack': DapDSStack
  }
}
